module.exports = __webpack_public_path__ + "img/v_3.a8fa8de8.png";